import { reactive } from "vue";
import { Module } from "vuex";
import { CreateOptionalUpgradeInterface, OptionalUpgrade, QueryOptionalUpgradeInterface, UpdateOptionalUpgradeInterface, optionalUpgradeDefault } from "@/types/OptionalUpgradeInterface";
import optionalUpgradeApi from "@/services/api/optionalUpgradeApi";

const state = reactive({
  ...optionalUpgradeDefault,
  selectedOptionalUpgradeId: null as string | null
});

export type optionalUpgradeState = typeof state;

const optionalUpgradeStore: Module<optionalUpgradeState, never> = {
  namespaced: true,
  state,
  mutations: {
    updateSelectedOptionalUpgradeId(state, optionalUpgradeId: string) {
      state.selectedOptionalUpgradeId = optionalUpgradeId;
    }
  },
  getters: {
    selectedOptionalUpgradeId: state => state.selectedOptionalUpgradeId
  },
  actions: {
    createOptionalUpgrade(_, params: CreateOptionalUpgradeInterface): Promise<OptionalUpgrade> {
      return optionalUpgradeApi.createOptionalUpgrade(params);
    },
    uploadImagesOptionalUpgrade(_, params: { builderId: string, image: FormData}) {
      return optionalUpgradeApi.uploadImagesOptionalUpgrade(params.builderId, params.image);
    },
    getOptionalUpgradesByBuilderId(_, params: { builderId: string }) {
      return optionalUpgradeApi.getOptionalUpgradesByBuilderId(params.builderId);
    },
    deleteOptionalUpgrade(_, params: { id: string }) {
      return optionalUpgradeApi.deleteOptionalUpgrade(params.id);
    },
    updateOptionalUpgrade(_, params: { dto: UpdateOptionalUpgradeInterface, id: string}) {
      return optionalUpgradeApi.updateOptionalUpgrade(params.id, params.dto);
    },
  },
};

export default optionalUpgradeStore;
